'use client';

import styled from 'styled-components';

export const StyledFAQ = styled.ul`
  list-style: none;
  width: 100%;
  padding: 0;
  margin: 0;
  color: var(--c-dark-grey-3);

  h3 {
    color: var(--c-dark-grey-4);
  }

  p {
    padding-left: var(--size-1);
  }
`;
